module.exports = __webpack_public_path__ + "img/sittracon.65fa9b6c.png";